import React, { useEffect, useRef, useState } from "react";
import { getGraphCoursePriceDetailsAction, getMoneyBackGuaranteeAction } from "@src/components/Tabs/Overview/store/actions";
import { useSelector , useDispatch } from "react-redux";
import { useRouter } from "@src/lib/router";
import { getIndividualInstallmentService } from "@src/components/Tabs/Overview/store/services";


const MoneyBackBottomDrawer = ({
     prePurchaseAddOnAmount,
     prePurchasePopUpEnabled,
    addOnOptionId, data }) => {
  
  const router = useRouter();
  const installmentData = useSelector((state)=> state?.overviewReducer?.overViewDetails?.course);

  const dispatch = useDispatch();
  const addMoneyBack = ()=>{
    dispatch(getMoneyBackGuaranteeAction({
      addOnOptionId:addOnOptionId,
      prePurchasePopUpEnabled:prePurchasePopUpEnabled,
      prePurchaseAddOnAmount:prePurchaseAddOnAmount,
      isRemoveButtonEnable:true,
    }))
   dispatch(getGraphCoursePriceDetailsAction({
      courseIds: [`${router.query.courseId}`],
      isBundlingCourse: false,
      avoidCouponsList: true,
      optedAddOn: addOnOptionId,
    }));
    getIndividualInstallmentService({
      courseId: installmentData?.metaData?.id || '',
      installmentId: installmentData?.installments?.activeInstallmentId || '',
      optedAddOn: addOnOptionId,
    })
  }

  const [isHidden, setIsHidden] = useState(false);
  return (
    <>
  {!isHidden ?       
    <div className="MoneyBackBottomDrawer">
        <div className="bottom-drawer-box">
          <img
            className="course-img"
            src={data?.icon}
            alt="img"
          />
          <h4>Add {data?.heading}</h4>
          <button className="add-btn" onClick={addMoneyBack}>
            <img
              src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/plush-vector-img.png"
              alt="add"
              width={13}
            />
            Add
          </button>
          <button className="close-btn">
          <img onClick={() => setIsHidden(true)}
          src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/close-white-img-icon.png"
          alt="close"
          width={20}
          />
          </button>
        </div>
      </div>:
      null
      }
    </>
  );
};
const MemoizedAboutCourse = React.memo(MoneyBackBottomDrawer);
export default MemoizedAboutCourse;
